/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Credential type enum for built-in GhostSpeak credentials */
export enum CredentialKind {
  AgentIdentity,
  ReputationScore,
  JobCompletion,
  DelegatedSigner,
  Custom,
}

export type CredentialKindArgs = CredentialKind;

export function getCredentialKindEncoder(): FixedSizeEncoder<CredentialKindArgs> {
  return getEnumEncoder(CredentialKind);
}

export function getCredentialKindDecoder(): FixedSizeDecoder<CredentialKind> {
  return getEnumDecoder(CredentialKind);
}

export function getCredentialKindCodec(): FixedSizeCodec<
  CredentialKindArgs,
  CredentialKind
> {
  return combineCodec(getCredentialKindEncoder(), getCredentialKindDecoder());
}
